<template>
  <div id="onlineschool">
    <v-layout>
      <v-card style="width:100%;background-color:#f5f5f5;">
          <v-toolbar dark color="primary">
            <v-btn small icon dark @click="$router.go(-1)">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Sekolah Online</v-toolbar-title>
          </v-toolbar>
      </v-card>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 v-for="(item, index) in moduleList" v-bind:key="index">
        <v-card style="margin-top: 10px; margin-right: 20px; margin-left: 20px; margin-bottom: 5px; padding:10px; border-radius: 13px;" @click="join(item)">
          <v-layout>
            <v-flex xs3 style="display:flex; justify-content:center;">
              <img :src="item.picture" alt="image-alt"/>
            </v-flex>
            <v-flex xs9 style="margin-top: 10px; padding-left: 10px;">
              <h2 style="font-size: 20px">{{item.name}}</h2>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="joinCode" id="confirmationelement" persistent>
      <v-card style="padding: 15px; padding-top:25px;padding-bottom:25px;border-radius: 10px;">
        <v-layout row wrap text-xs-center>
          <v-flex xs12>
              <h3 style="margin-bottom: 10px;">Masukkan Kode Sekolah</h3>
              <v-text-field
                solo
                id="joincode"
                label="Kode Sekolah"
                v-model="code"
                :maxlength="10"
                max="10"
                append-inner-icon="pencil"
              ></v-text-field>
            <v-btn normal color="#3cb54a" style="margin-bottom:10px;" dark block round @click="validate()">MASUK</v-btn>
            <v-btn normal light block round @click="close()">TUTUP</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="successSign" id="success-card" persistent >
      <v-layout row wrap>
        <v-flex xs12>
          <img src="@/assets/icon/success.gif" alt="image-alt"/>
        </v-flex>
        <v-flex xs12>
          <div class="tag-success">
          Berhasil ...
        </div>
        </v-flex>
      </v-layout>

    </v-dialog>

    <v-dialog v-model="wrongCode" persistent>
      <v-card style="padding: 15px; padding-top:25px;padding-bottom:25px; border-radius: 10px;">
        <v-layout row wrap text-xs-center>
          <v-flex xs12>
              <img src="@/assets/icon/ic_aksesditolak.svg" alt="image-alt"/>
              <h3 style="color:#0c9cd6; margin-top: 5px; margin-bottom: 5px;">
                  Akses Ditolak!
              </h3>
              <h4 style="margin-bottom: 10px;">Kode yang kamu masukkan salah.</h4>
              <!-- <h3 style="margin-bottom: 10px;">Masukkan Kode Sekolah</h3> -->
            <v-btn normal color="#3cb54a" style="margin-bottom:10px;" dark block round @click="tryagain()">MASUKKAN KODE KEMBALI</v-btn>
            <v-btn normal light block round @click="close()">TUTUP</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
#joincode {
  height: 30px;
  font-size:20px;
}

.success-card {
  /* width: 50px; */
  margin: 100px;
}

.v-dialog.v-dialog--active.v-dialog--persistent {
  box-shadow: none;
}
.tag-success {
  text-align: center;
  font-size: 20px;
  color: white;
  background-color: #00cfad;
  width: fit-content;
  margin: 0 auto;
  padding: 10px;
  border-radius: 10px;
}
</style>

<script>
// import { mapGetters } from 'vuex'
/* eslint-disable */
export default {
  name: 'online-school-component',
  data () {
    return {
      joinCode: false,
      moduleList: [],
      module: null,
      code: null,
      successSign: false,
      wrongCode: false
    }
  },
  methods: {
    close() {
      this.module = null
      this.joinCode = false
      this.wrongCode = false
    },
    join(item) {
      this.module = item
      this.joinCode = true
    },
    tryagain() {
      this.wrongCode = false 
      this.joinCode = true
    },
    validate() {
      // this.$router.push('/online-school/list')
      var params = [this.module.id, this.code]
      this.$store.dispatch('funcGetVerificationModule', params).then(response => {
        // this.$router.push('/online-school/list')
        this.successSign = true
        this.joinCode = false
        var context = this
        var storage = {
          module_id: this.module.id,
          school_name: this.module.name,
          joinCode: this.code
        }
        sessionStorage.onlineSchool = JSON.stringify(storage)
        setTimeout(function(){ context.$router.push('/online-school/list') }, 3000)
      }).catch(error => {
        if (error) {}
        var err = JSON.stringify(error)
        err = JSON.parse(err)
        if(err.response.data.status === 404) {
          this.wrongCode = true
          this.joinCode = false
        }
      })
    },
    fetchData() {
      this.$store.dispatch('funcGetModuleList').then(response => {
        this.moduleList = response.data
      })
    }
  },
  created() {
    this.fetchData()
    sessionStorage.onlineSchool = ''
  }
}
</script>
